import { render } from "./GeneratorTemplates.vue?vue&type=template&id=22372b58&scoped=true"
import script from "./GeneratorTemplates.vue?vue&type=script&lang=js"
export * from "./GeneratorTemplates.vue?vue&type=script&lang=js"

import "./GeneratorTemplates.vue?vue&type=style&index=0&id=22372b58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22372b58"]])

export default __exports__